import 'slick-carousel'
import 'jquery.easing'
import GET_ARTICLES from '../plugins/getArticles'
import GET_CATEGORIES from '../plugins/getCategories'
import GET_INSTAGRAM from '../plugins/getInstagram'
import LAZY_DISP from '../plugins/lazydisp'

const [ w, d, l ] = [ window, document, location ]

const slider = {
  obj : '.p-slider',
  animationDuration: 8300,
  init(){
    $(this.obj).slick({
      arrows: false,
      dots: true,
      infinite: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4500,
      speed: 2000,
      pauseOnHover: false,
      pauseOnFocus: false,
    })
    $(this.obj).on('beforeChange',( e, slick, cs, ns ) => {
      $('.p-mainvisual__lead').attr('data-slide', ns )
      $(`[data-slick-index=${ns}]`).addClass('is-animation-start')
      setTimeout( () => $(`[data-slick-index=${ns}]`).removeClass('is-animation-start'),
        this.animationDuration
      )
    })
  },
  start() {
    $(this.obj).slick('slickPlay').addClass('is-slickPlay')
    $(`[data-slick-index=0]`).addClass('is-animation-start')
    setTimeout( () => $(`[data-slick-index=0]`).removeClass('is-animation-start'),
      this.animationDuration
    )
  }
}

const splash_screen = () => {
  let $splash = $(`
    <div class="p-splash">
      <img src="/asset/img/home/intro.jpg" width="452" />
      <div class="progress"></div>
    </div>
  `)
  d.body.appendChild( $splash[0] )
  d.documentElement.style.opacity = 1
  let progress = d.querySelector('.p-splash .progress')
  let progress_goto = per => $(progress).css( 'width', `${per}%` )
  let percentage = 0
  let loading_loadHtml = blocks => {
    let ratio = parseFloat( 50 / blocks.length )
    let resolve = () => {
      percentage += ratio
      progress_goto( percentage )
    }
    Array.prototype.forEach.call( blocks, b => w.load[b.dataset.loadHtml].then( resolve ) )
  }
  $(() => loading_loadHtml( d.querySelectorAll('[data-load-html]') ) )
  $.when( w.load['loadHtml'] ).done( () => {
    setTimeout( slider.init(), 1000 )
    if( d.querySelectorAll('img').length == 0 ) {
      progress_goto(100)
      return true
    }
    let images = d.querySelectorAll('img')
    let ratio = parseFloat( 50 / images.length )
    let defs = []
    let min_timer = new $.Deferred
    defs.push( min_timer )
    setTimeout( min_timer.resolve, 1500 )
    Array.prototype.forEach.call( images, obj => {
      let def = new $.Deferred
      let resolve_image = () => {
        percentage += ratio
        progress_goto( percentage )
        def.resolve()
      }
      defs.push( def )
      if( obj.complete ) resolve_image()
      else{
        obj.addEventListener('load', resolve_image )
        obj.addEventListener('error', resolve_image )
        if(obj.height > 0) setTimeout( resolve_image, 2000 )
      }
    })
    // $.when.apply( $, defs ).then( () => {
    //   $splash.addClass('is-start')
    //   setTimeout(
    //     () => $splash.fadeOut( 1800, 'easeOutExpo', slider.start() ),
    //     800
    //   )
    // })
    min_timer.then( () => {
      $splash.addClass('is-start')
      setTimeout(
        () => $splash.fadeOut( 1800, 'easeOutExpo', slider.start() ),
        800
      )
    })
  })
}

const init = () => {

  //ticker
  $.when( w.load['block-ticker'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="date">${item.date}</span>
        <span class="cat">【${item.category.name}】</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.p-ticker__article[data-plugin="getArticles"]', { makeItem })
  })

  // pickup
  $.when(
    $.getFreeBlock({id: 2, timestamp: '20201021'}),
    w.load['block-ticker']
  ).then( res => {
    let $link = $('a[href]', `<div>${res}</div>` )
    let $container = $(`<section class="p-userBan" data-plugin="slider"></section>`)
    $link.each((i, v) => {
      $container.append($(v).addClass('banner')[0].outerHTML)
    })

    // デフォルトのご挨拶ブロックを削除
    $('.element.conceptelement','#main').parents('.block.block_head').remove()
    if( $link != undefined ) $('.p-ticker__wrap').append( $container )

    // バナースライダー発動
    $('.p-userBan').slick({
      autoplay: true,
      fade: false,
      dots: true,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      variableWidth: false,
      arrows: false
    });
  })

  // event
  $.when( w.load['block-events'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="p-block-event-item">
        <figure class="p-block-event-item__img">
          <div class="p-block-event-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="100%" height="100%" loading="lazy"></div>
        </figure>
        <div class="p-block-event-item__body">
          <h4>${item.title}</h4>
          <p>${$.strip_tags(item.body).str_truncate( 40 )}</p>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.p-block-events__list[data-plugin="getArticles"]',{ makeItem })
  })

  // galleries
  $.when( w.load['block-galleries'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="p-block-galleries-item">
        <figure class="p-block-galleries-item__cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="300" height="200" loading="lazy"></figure>
        <div class="p-block-galleries-item__desc">
          <h4 class="p-block-galleries-item__title">${item.title}</h4>
          <button class="button-border-white">READ MORE</button>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.p-block-galleries__list[data-plugin="getArticles"]', { makeItem })
  })

  // members
  $.when( w.load['block-members'] ).then( () => {
    let makeItem = item => {
      let data = item.desc.split('|')
      let name = data[0].replace(/^\s|\s$/m,'').replace(/(.+)\s(.+)/,'$1<br>$2')
      let sex = data[2].replace(/^\s|\s$/m,'') || ''
      return $(`
        <a href="${item.href}" class="p-block-members-item is-${sex}">
          <figure class="p-block-members-item__cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="200" height="200" loading="lazy"></figure>
          <div class="p-block-members-item__body"><h4>${name}</h4></div>
        </a>
      `)[0]
    }
    let getMember = GET_ARTICLES('.p-block-members__list[data-plugin="getArticles"]', { makeItem })
    getMember.then( () => {
      let $list = $('.p-block-members__list')
      let slickOpt = {
        dots: false,
        centerMode: true,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        centerPadding: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000
      }
      if( $list.children('a').length == 0 ) return false
      if( $list.children('a').length < 4 ) $list.children('a').clone( true ).appendTo( $list )
      $list.slick( slickOpt )
    })
  })

  // topics
  $.when( w.load['block-topics'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="p-block-topics-item">
        <figure class="p-block-topics-item__img">
          <div class="p-block-topics-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="100%" height="100%" loading="lazy"></div>
        </figure>
        <div class="p-block-topics-item__body">
          <span class="cate">${item.category.name}</span>
          <h4 class="subject">${item.title}</h4>
          <p>${$.strip_tags(item.body).str_truncate( 40 )}</p>
          <span class="date">${item.date}</span>
        </div>
      </a>
    `)[0]
    GET_CATEGORIES('.p-block-topics__categories[data-plugin="getCategories"]')
    GET_ARTICLES('.p-block-topics__list[data-plugin="getArticles"]', { makeItem })
  })

  // kurashi plus
  $.when( w.load['block-kurashiplus'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="p-block-kurashiplus-item">
        <figure class="p-block-kurashiplus-item__img">
          <div class="p-block-kurashiplus-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="180" height="180" loading="lazy"></div>
        </figure>
        <div class="p-block-kurashiplus-item__body"><h4>${item.title}</h4></div>
      </a>
    `)[0]
    GET_ARTICLES('.p-block-kurashiplus__list[data-plugin="getArticles"]',{ makeItem })
  })

  // sns
  $.when( w.load['block-sns'] ).then( () => {
    let fbroot = d.createElement('div')
    fbroot.id = 'fb-root'
    d.body.appendChild( fbroot )
    w.addScript({
      async: '',
      defer: '',
      crossorigin: "anonymous",
      src: "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v7.0",
      nonce: "n5Xi5Pjk"
    })
    GET_INSTAGRAM()
  })

  // 画面固定ボタンをスクロール量で表示する
  $.when( w.load['footer'] ).then( () => {
    $('.p-fixedbanner').addClass('hidden')
    $.scrollspy({
      trigger: window.innerHeight,
      onBefore () {
        $('.p-fixedbanner').addClass('hidden')
      },
      onAfter () {
        $('.p-fixedbanner').removeClass('hidden')
      }
    })
  })
}

export default function HOME() {

  d.addEventListener('DOMContentLoaded', splash_screen )
  $(() => init() )

}
